import { render, staticRenderFns } from "./DownPayment.vue?vue&type=template&id=b4e4ef82&scoped=true"
import script from "./DownPayment.vue?vue&type=script&lang=js"
export * from "./DownPayment.vue?vue&type=script&lang=js"
import style0 from "./DownPayment.vue?vue&type=style&index=0&id=b4e4ef82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e4ef82",
  null
  
)

export default component.exports